import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "rewind-banners",
    ref: "stack",
    class: "rewind-banners"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FrozenBanner = _resolveComponent("FrozenBanner");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.frozen)
                ? (_openBlock(), _createBlock(_component_FrozenBanner, { key: 0 }))
                : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", {
            class: "rewind-banners-spacer",
            style: _normalizeStyle({ height: _ctx.height + 'px' })
        }, null, 4)
    ], 64));
}
